import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Creatable from 'react-select/lib/Creatable';
import Select from 'react-select';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import Fetch from '../../../../../services/Fetch';
import FieldWrap from '../../FieldWrap/FieldWrap';
import { apiURL } from '../../../../../constants';
import { selectPlaceholder } from '../../../utils/constants';

var CometaSearchComponent = /*#__PURE__*/function (_Component) {
  _inherits(CometaSearchComponent, _Component);

  function CometaSearchComponent(props) {
    var _this;

    _classCallCheck(this, CometaSearchComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CometaSearchComponent).call(this, props));

    _this.setAvailableOptions = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var prefillOptions = _this.state.prefillOptions;
      var newOptions = uniqBy(prefillOptions.concat(options), 'code');

      if (_this._isMounted) {
        _this.setState({
          options: newOptions
        });
      }
    };

    _this.setInitialOption = function (value) {
      var hasMultipleOptions = Array.isArray(value);

      if (hasMultipleOptions) {
        var fetchedOptions = value.map(_this.fetchExactOption);
        Promise.all(fetchedOptions).then(function (fetchedOptions) {
          _this.setAvailableOptions(fetchedOptions);
        });
      } else {
        _this.fetchExactOption(value).then(function (fetchedOption) {
          _this.setAvailableOptions([fetchedOption]);
        });
      }
    };

    _this.fetchExactOption = function (searchTerm) {
      var _this$props = _this.props,
          listName = _this$props.listName,
          country = _this$props.country;
      var search = searchTerm.value || searchTerm;
      return Fetch.getJSON("".concat(apiURL.API_COMETA, "/").concat(listName, "?searchTerm=").concat(search, "&exact=true&country=").concat(country));
    };

    _this.fetchOptions = function (searchTerm) {
      var _this$props2 = _this.props,
          listName = _this$props2.listName,
          country = _this$props2.country;
      Fetch.getJSON("".concat(apiURL.API_COMETA, "/").concat(listName, "?searchTerm=").concat(searchTerm, "&country=").concat(country)).then(function (options) {
        _this.setAvailableOptions(options);
      });
    };

    _this.fetchPrefillOptions = function () {
      var _this$props3 = _this.props,
          listName = _this$props3.listName,
          country = _this$props3.country;
      return Fetch.getJSON("".concat(apiURL.API_COMETA, "/").concat(listName, "?country=").concat(country, "&prefill=true")).then(function (prefillOptions) {
        if (_this._isMounted) {
          _this.setState({
            prefillOptions: prefillOptions
          });
        }
      });
    };

    _this.handleInputChange = debounce(function (inputValue) {
      if (!inputValue || inputValue.length < 3) {
        return;
      }

      _this.fetchOptions(inputValue);
    }, 250);

    _this.handleChange = function (option) {
      var _this$props4 = _this.props,
          input = _this$props4.input,
          handleChange = _this$props4.handleChange,
          isMulti = _this$props4.isMulti; // save value

      if (isMulti) {
        // dispatch to redux store
        input.onChange(option.map(function (o) {
          return o.value;
        }));
        return handleChange(option.map(function (o) {
          return o.value;
        }));
      } // dispatch to redux store


      input.onChange(option.value);
      handleChange(option.value);
    };

    _this.state = {
      prefillOptions: [],
      options: []
    };
    _this._isMounted = false;
    return _this;
  }

  _createClass(CometaSearchComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var value = this.props.input.value;
      this._isMounted = true;
      this.fetchPrefillOptions().then(function () {
        if (value) {
          return _this2.setInitialOption(value);
        }

        _this2.setAvailableOptions();
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          input = _this$props5.input,
          isCreatable = _this$props5.isCreatable,
          isClearable = _this$props5.isClearable,
          isMulti = _this$props5.isMulti,
          label = _this$props5.label,
          displayNotes = _this$props5.displayNotes,
          meta = _this$props5.meta,
          language = _this$props5.language,
          placeholder = _this$props5.placeholder,
          id = _this$props5.id;
      var options = this.state.options;
      var value = [];
      var adapterOptions = options.map(function (option) {
        var label = option.code;

        if (language === 'en') {
          label = option.title_en;
        }

        if (language === 'es') {
          label = option.title_es;
        }

        if (language === 'pt-BR') {
          label = option.title_pt;
        }

        return _extends({}, option, {
          value: option.code,
          label: label
        });
      }).filter(function (o) {
        return o.label;
      });

      if (isMulti && input.value && input.value.length) {
        value = adapterOptions && adapterOptions.filter(function (o) {
          return input.value.indexOf(o.value) > -1;
        });
      } else {
        value = adapterOptions && adapterOptions.find(function (o) {
          return o.value === input.value;
        });
      }

      var ChosenSelectComponent = isCreatable ? Creatable : Select;
      return React.createElement('div', {
        className: 'form-group SelectComponentField'
      }, React.createElement('label', null, label), React.createElement(FieldWrap, {
        meta: meta,
        displayNotes: displayNotes
      }, React.createElement('div', {
        notranslate: 'true'
      }, React.createElement(ChosenSelectComponent, {
        id: id,
        isClearable: isClearable,
        isMulti: isMulti,
        value: value,
        options: adapterOptions,
        onInputChange: this.handleInputChange,
        onChange: this.handleChange,
        onFocus: function onFocus() {
          return input.onFocus();
        },
        onBlur: function onBlur() {
          return input.onBlur();
        },
        placeholder: placeholder || selectPlaceholder[language]
      }))));
    }
  }]);

  return CometaSearchComponent;
}(Component);

CometaSearchComponent.propTypes = {
  listName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  id: PropTypes.string,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string
  })
};
export default CometaSearchComponent;